import { FaAngleRight } from "react-icons/fa6";
import { MdOutlineKeyboardBackspace } from "react-icons/md";
import { Link } from "react-router-dom";
import { GoPencil } from "react-icons/go";
import OrderAndMenuTable from "../Restaurants/Operations/OrderAndMenuTable";

const orderNavData = [
  {
    title: "Active Orders",
    amount: 23,
  },
  {
    title: "Delayed Orders",
    amount: 23,
  },
  {
    title: "Delivered Today",
    amount: 23,
  },
  {
    title: "Average Delivery Time",
    amount: 23,
  },
];

const OrderMonitoring = () => {
  return (
    <section className="font-mont">
      <div className="flex items-start gap-4">
        <Link to="/dashboard/restaurants">
          <button className="cursor-pointer p-2 rounded-full bg-[#008B5014]">
            <MdOutlineKeyboardBackspace className="w-6 h-6" />
          </button>
        </Link>
        <article>
          <h1 className="text-2xl font-medium mb-2 inline-flex items-center gap-3">
            <span className="font-semibold">Operations</span> <FaAngleRight />
            Order Monitoring
          </h1>
          <p className="text-sm">
            Track and manage orders across all vendors in real-time.
          </p>
        </article>
      </div>
      
      <section className="bg-[#EEEEEE40] px-3 py-5 my-3">
        <article className="bg-white px-4 py-7 my-5 flex items-center gap-3 justify-between">
          {orderNavData.map((item) => (
            <div
              key={item.title}
              className="w-64 border rounded-md py-3 px-5"
            >
              <div className="flex items-center justify-between">
                <h3 className="text-sm">{item.title}</h3>
                <div className="p-3 rounded-full border">
                  <GoPencil className="w-3 h-3" />
                </div>
              </div>
              <p className="text-lg font-medium">{item.amount}</p>
            </div>
          ))}
        </article>
        
        <OrderAndMenuTable table="orders" />
      </section>
    </section>
  );
};

export default OrderMonitoring;